import React, { ChangeEvent } from 'react';
import { inputSliceActions, selectEventTime, selectEventTimeFocused } from '../../features/input/inputSlice';
import TextInput from '../../styled/components/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import { selectTime } from '../../features/time/timeSlice';

const MAX_MATCH_EVENT_MINUTES = 999;
const MAX_MATCH_EVENT_SECONDS = 60;

const EventTime: React.FC = () => {
  const dispatch = useDispatch();

  const isEventTimeFocused = useSelector(selectEventTimeFocused);
  const matchTime = useSelector(selectTime);
  const eventTime = useSelector(selectEventTime);

  let displayEventTime: any;
  if (isEventTimeFocused) {
    displayEventTime = eventTime;
  } else {
    displayEventTime = eventTime || matchTime.minutes + ':' + matchTime.seconds.toString().padStart(2, '0');
  }

  const updateEventTime = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const trimmedValue = value.trim();
    if (trimmedValue === '') {
      dispatch(inputSliceActions.setEventTime(''));
    } else if (trimmedValue && /^\d+(:[\d]{0,2})?$/.test(trimmedValue)) {
      const parts = trimmedValue.split(':');
      const minutes = Number(parts[0]);
      const seconds = parts.length === 2 && parts[1] !== '' ? Number(parts[1]) : 0;
      if (minutes <= MAX_MATCH_EVENT_MINUTES && seconds < MAX_MATCH_EVENT_SECONDS) {
        dispatch(inputSliceActions.setEventTime(trimmedValue));
      }
    }
  };

  return (
    <TextInput
      tiny
      type="string"
      value={displayEventTime ? displayEventTime.toString() : ''}
      onChange={updateEventTime}
      onFocus={() => dispatch(inputSliceActions.setEventTimeFocused(true))}
      autoFocus
    />
  );
};

export default EventTime;
